import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { ApiClientService } from "~app/common/services/api-client.service";
import {
    MoveLeverantorResponseDTO,
    MoveLeverantorerRequestDTO,
    SearchVirkesleverantorForMoveRequestDTO,
    SearchVirkesleverantorForMoveResponseDTO
} from "../dialog/move-leverantorer-dialog/models/searchvirkesleverantorer.models";
import { ISearchVirkesleverantor, ISearchVirkesleverantorRequest } from "../models/virkesleverantorModel";

@Injectable({
    providedIn: "root"
})
export class VirkesleverantorService {
    private readonly apiClient = inject(ApiClientService);

    getAnvandareTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();

        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient.post<any, ITypeAheadResult[]>("typeahead/anvandare", { query: input,
            addUserUserNameToName: true }, false, null, ApiClientService.JsonHeader);
    }

    getVirkesKopareTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();

        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient.post<any, ITypeAheadResult[]>("virkeskop/kopare/typeahead", JSON.stringify(input), false, null, ApiClientService.JsonHeader);
    }

    getVirkesleverantorTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();

        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient.post<any, ITypeAheadResult[]>("virkeskop/leverantor/typeahead", JSON.stringify(input), false, null, ApiClientService.JsonHeader);
    }

    searchForVirkeskopsleverantor(param: ISearchVirkesleverantorRequest): Observable<ISearchVirkesleverantor[]> {
        return this.apiClient.post<ISearchVirkesleverantorRequest, ISearchVirkesleverantor[]>(`virkesleverantor/search`, param);
    }

    searchForVirkeskopsleverantorerForMove(param: SearchVirkesleverantorForMoveRequestDTO): Observable<SearchVirkesleverantorForMoveResponseDTO[]> {
        return this.apiClient.post<SearchVirkesleverantorForMoveRequestDTO,SearchVirkesleverantorForMoveResponseDTO[]>(`virkesleverantor/searchformove`, param);
    }

    moveLeverantorer(fromAnvandareId: number, toAnvandareId: number, moveLeverantorIds: number[]): Observable<MoveLeverantorResponseDTO> {
        const request: MoveLeverantorerRequestDTO = {
            fromAnvandareId: fromAnvandareId,
            toAnvandareId: toAnvandareId,
            leverantorIds: moveLeverantorIds
        };

        return this.apiClient.post<MoveLeverantorerRequestDTO, MoveLeverantorResponseDTO>("virkesleverantor/moveleverantorer", request, false);
    }
}
